
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React, { useEffect } from "react";

import { useRouter } from "next/router";
import qs from "query-string";
import { DISCORD_AUTH_LINK } from "../../../utils/constants";

const Index = () => {
  const router = useRouter();

  useEffect(() => {
    const {
      query: { guildId, userId },
    } = qs.parseUrl(router.asPath); // router.query is empty on mount

    if (!guildId || !userId) {
      router.replace(DISCORD_AUTH_LINK);
      return;
    }

    const params = qs.stringify({
      serverId: guildId,
      customerId: userId,
    });

    router.replace(
      `${process.env.NEXT_PUBLIC_TELEGRAM_BOT_API_URL}/payment/link?${params}`
    );
  }, [router]);

  return null;
};

export default Index;


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/discord-telegram/checkout/index',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              
            }))
          }
        }
    }
  